import { create } from 'zustand';

const initialState = {
    isOpen: false,
    mode: 'create',
    form: {},
    initialData: null,
};

export const useSkuUpsertModal = create((set, get) => ({
    ...initialState,

    openCreate: () =>
        set(() => ({
            isOpen: true,
            mode: 'create',
            form: {},
            initialData: null,
        })),

    openEdit: (data) =>
        set(() => ({
            isOpen: true,
            mode: 'edit',
            form: data || {},
            initialData: data || {},
        })),

    close: () =>
        set((state) => ({
            ...state,
            isOpen: false,
        })),

    setFields: (payload) =>
        set((state) => ({
            form: {
                ...state.form,
                ...payload,
            },
        })),

    validateForm: (config) => {
        const { form } = get();

        return config.every((field) => {
            if (!field.required) return true;
            return !!form[field.name];
        });
    },

    reset: () => set(initialState),
}));
